import { render, staticRenderFns } from "./TakeMeal.vue?vue&type=template&id=542ca435&scoped=true"
import script from "./TakeMeal.vue?vue&type=script&lang=js"
export * from "./TakeMeal.vue?vue&type=script&lang=js"
import style0 from "./TakeMeal.vue?vue&type=style&index=0&id=542ca435&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542ca435",
  null
  
)

export default component.exports